;(() => {
  const MAX_MB = 8;
  const expr = '.resume-js';
  const init = () => {
    if (location.href.indexOf('customer/recruitment_application/new') < 0 && location.href.indexOf('customer/recruitment_application/store') < 0) return;
    $('body').on('change', expr, onChanged);
  };
  const onChanged = e => {
    const $element = $(e.currentTarget);
    const $label = $('.resume-label');
    const selectedFile = $element[0].files;
    if (maxMbToBytes() < selectedFile[0].size) {
      $element.val();
      alert(`送信可能なファイル容量は、${MAX_MB}MBまでです。`);
      return;
    }

    $label.addClass('changed').attr('data-text', selectedFile[0]['name']);
  };
  const maxMbToBytes = () => {
    return MAX_MB * 1024 * 1024;
  };
  $(init);
})();
